module.exports = __webpack_public_path__ + "media/recipes/52-6a66dfa7.png";